import { render, staticRenderFns } from "./userTuiSim.vue?vue&type=template&id=5e4267b0&"
import script from "./userTuiSim.vue?vue&type=script&lang=js&"
export * from "./userTuiSim.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports